import { useTranslation } from "react-i18next";

const GiftCard = ({ item }) => {
    const { t } = useTranslation();

    return (
        <div className="rounded-3xl border border-slate-200 bg-white px-5 py-6 text-center shadow-[0_10px_20px_rgba(15,23,42,0.06)] md:px-6 md:py-8">
            <div className="flex h-32 items-center justify-center md:h-40">
                {item.image ? (
                    <img src={item.image} alt="" className="max-h-28 object-contain md:max-h-36" />
                ) : (
                    <img src="/assets/icons/korres-shares-logo.png" alt="" className="h-[4.5rem] w-[4.5rem] object-contain" />
                )}
            </div>
            <p
                title={item.name}
                className="mx-auto min-h-[3.9rem] max-w-[210px] overflow-hidden text-center text-ellipsis whitespace-normal break-words text-base font-medium leading-[1.2] text-slate-900 line-clamp-2"
            >
                {item.name}
            </p>
            <p className="mt-3 text-center text-xs text-slate-500">
                {t("COMMON_CODE")}: {item.code}
            </p>
            <p className="mt-8 text-center text-sm font-medium">
                {t("COMMON_GIFT_VALUE")}: {item.price}
            </p>
        </div>
    );
};

export default GiftCard;
